import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/axios';

export interface TaskItem {
  _id: string;
  title: string;
  description?: string;
  status: string;
  priority: string;
  assigned_to?: string;
  assigned_name?: string;
  /** Real field name returned by GET /api/tasks (Tasks.list in db-mongo.js). */
  assignee_name?: string;
  project_id?: string;
  project_name?: string;
  due_date?: string;
  created_at?: string;
}

export function useMarketingTasks() {
  return useQuery<TaskItem[]>({
    queryKey: ['marketing-tasks'],
    queryFn: async () => {
      const res = await api.get('/api/tasks');
      return res.data?.tasks ?? res.data ?? [];
    },
    staleTime: 60_000,
  });
}
